import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  LinearProgress,
  Modal,
} from "@mui/material";
import React, { useState } from "react";

import { JOB_SERVER_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import {
  fetchProperties,
  selectProperties,
} from "../../views/Properties/propertiesSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchAllRowsFilters,
  fetchMaiFilters,
  fetchMedchemFilters,
  fetchPropertiesV2,
  fetchToxicFilters,
} from "../../views/Properties/propertiesSliceV2";
import { useDispatch } from "react-redux";
import { fetchAdmeProperties } from "../../views/AdmeTox/AdmeSlice";
import { fetchAutoDockProperties } from "../../views/Docking/dockingSlice";
import { fetchPromiscuityResults } from "../../views/Promiscuity/promiscuitySlice";
import http from "../../net/http-common";
import { fetchScreenieProperties } from "../../views/Properties/PropertiesSliceV3";
import { fetchLiftFilterData } from "../../views/LiftFilter/liftFilterSlice";
import { fetchRankerProperties } from "../../views/Ranker/rankerSlice";
import { fetchLeaderReinventProperties } from "../../views/leaderReinvent/leaderReinventSlice";
import { fetchBioisostericProperties } from "../../views/Bioisosteric/BioisostericSlice";
import { useUserAuth } from "../../context";
import JobStatusDialog from "./JobStatusDialog";
import { errorMessages } from "../../common_variables/ErrorMsgs";
import {
  fetchNCIResults,
  fetchRBFEResults,
} from "../../views/Lodestar/LodestarSlice";
import useEventTracker from "../Analytics/eventHook";
import { allModuleEvents } from "../Analytics/events";
import {
  GlobalMsgAlertStateType,
  setGlobalMsgAlerts,
} from "../GloablMsgAlerts/globalMsgAlertsSlice";
import { fetchHopperResults } from "../../views/Hopper/hopperSlice";
import { fetchGenieProperties } from "../../views/Genie/genieSlice";
import { isAxiosError } from "axios";

interface Job {
  job: any;
  handleBackdrop?: (status: boolean) => void;
  disableDownload?: boolean;
  disableVisualize?: boolean;
  nextUrl?: string;
  setShowError?: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorMsg?: React.Dispatch<any>;
  onSuccessfullJobSubmission?: (jobId: number) => void;
}

function downloadAutoMolResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/automol/results`, {
      params: {
        task_id: task_id,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `automol_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadTargetDiffResults(task_id: string, MODEL_NAME: string) {
  return http
    .get(`${JOB_SERVER_URL}/targetdiff/results`, {
      params: {
        task_id: task_id,
        model_name: MODEL_NAME,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `diffmol_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadMaimolResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/maimol_pipeline/results`, {
      params: {
        task_id: task_id,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadDiffDockResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/diffdock/results`, {
      params: {
        task_id: task_id,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data.ligand]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `diffdock_${task_id}.sdf`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadADMEToxResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/adme_tox/results`, {
      params: {
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `adme_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadAutoDockResults(task_id: string, MODEL_NAME?: string) {
  return http
    .get(`${JOB_SERVER_URL}/dock/results`, {
      params: {
        model_name: MODEL_NAME,
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `docking_scores_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadPromiscuityResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/pmsfilter/results`, {
      params: {
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `promiscuity_scores_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadScreenieResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/screenie/results`, {
      params: {
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `screenie_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadliftResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/lift/results`, {
      params: {
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `${task_id}.jsonl`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadReinventResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/reinvent/results`, {
      params: {
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));

      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `reinvent_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadBioisoResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/bioiso/results`, {
      params: {
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const href = window.URL.createObjectURL(new Blob([response.data]));
      const anchorElement = document.createElement("a");

      anchorElement.href = href;
      anchorElement.download = `bioiso_${task_id}.csv`;

      document.body.appendChild(anchorElement);
      anchorElement.click();
      document.body.removeChild(anchorElement);
      window.URL.revokeObjectURL(href);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadRBFEResults(task_id: string) {
  return http
    .get(`${JOB_SERVER_URL}/rbfe/results/${task_id}`, {
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const link = document.createElement("a");
      link.href = response.data.result.output_json;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadMDResults(task_id: string, resultType?: string) {
  return http
    .get(`${JOB_SERVER_URL}/md_simulation/results/${task_id}`, {
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const link = document.createElement("a");
      if (resultType === "protein") {
        link.href = response.data.result.protein;
      } else {
        link.href = response.data.result.trajectory;
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      throw error;
    });
}

function downloadNCIResults(task_id: string, resultType?: string) {
  return http
    .get(`${JOB_SERVER_URL}/nci_analysis/results/${task_id}`, {
      headers: {
        accept: "application/json",
      },
    })
    .then((response) => {
      const link = document.createElement("a");
      if (resultType === "csv") {
        link.href = response.data.result.output_csv;
      } else {
        link.href = response.data.result.output_png;
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })

    .catch((error) => {
      throw error;
    });
}

const fetchMDResults = async (task_id: string) => {
  try {
    const response = await http.get(
      `${JOB_SERVER_URL}/md_simulation/results/${task_id}`,
      {
        headers: {
          accept: "application/json",
        },
      }
    );

    const protein = await fetch(response.data.result.protein, {
      method: "GET",
    });
    const proteinBlob = await protein.blob();
    const pdbFile = new File([proteinBlob], "structure1.pdb");

    const trajectoryResponse = await fetch(response.data.result.trajectory, {
      method: "GET",
    });
    const trajBlob = await trajectoryResponse.blob(); // Use .blob() to get binary data
    const trajFile = new File([trajBlob], "trajectory1.xtc", {
      type: "application/octet-stream",
    });

    return { pdbFile, trajFile };
  } catch (error) {
    throw error;
  }
};

async function downloadGenieResults(task_id: string) {
  try {
    const response = await http.get(
      `${JOB_SERVER_URL}/maimol_pipeline/results/genie?task_id=${task_id}`,
      {
        headers: {
          accept: "application/json",
        },
      }
    );
    const href = window.URL.createObjectURL(new Blob([response.data]));

    const anchorElement = document.createElement("a");

    anchorElement.href = href;
    anchorElement.download = `${task_id}.csv`;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  } catch (error) {
    throw error;
  }
}

async function downloadHopperResults(task_id: string) {
  try {
    const response = await http.get(`${JOB_SERVER_URL}/hopper/results?`, {
      params: {
        task_id: task_id,
        as_file: true,
      },
      headers: {
        accept: "application/json",
      },
    });

    const href = window.URL.createObjectURL(new Blob([response.data]));

    const anchorElement = document.createElement("a");

    anchorElement.href = href;
    anchorElement.download = `${task_id}.csv`;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  } catch (error) {
    throw error;
  }
}

function JobDetails(props: Job) {
  const MODEL_NAME: string = props.job.model || "Unknown Module";
  const TASK_ID: string = props.job.id;
  const from_model: boolean = true;
  const [resultAvailable, setResultAvailable] = useState(true);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [smiles, setSmiles] = useState("");
  const [smilesFile, setSmilesFile] = useState("");
  const [downloadResultLoader, setDownloadResultLoader] =
    useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [dialogData, setDialogData] = useState(null);

  const { trackEvent } = useEventTracker(MODEL_NAME);

  const { user } = useUserAuth();

  const dispatchForAction = useDispatch<any>();

  const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#d99e9e",
    pt: 2,
    px: 4,
    pb: 3,
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  const visualizeResults = async () => {
    switch (MODEL_NAME) {
      case "targetdiff":
        launchPropertyExplorer(MODEL_NAME, TASK_ID, from_model);
        break;
      case "tagmol":
        launchPropertyExplorer(MODEL_NAME, TASK_ID, from_model);
        break;
      case "diffdock":
        launchDockingViewer(MODEL_NAME, TASK_ID, from_model);
        break;
      case "adme_tox":
        localStorage.removeItem("AdmeTableState");
        dispatchForAction(fetchAdmeProperties(props.job.id));
        break;
      case "autodock":
        localStorage.removeItem("dockingTable");
        dispatchForAction(fetchAutoDockProperties({ task_id: props.job.id }));
        // dispatchForAction(fetchPreparedLigands(props.job.id));
        break;
      case "unidock":
        dispatchForAction(
          fetchAutoDockProperties({
            task_id: props.job.id,
            model_name: MODEL_NAME,
          })
        );
        break;
      case "promiscuity":
        dispatchForAction(fetchPromiscuityResults(props.job.id));
        break;
      case "screenie":
        localStorage.removeItem("screenieTableState");
        dispatchForAction(fetchScreenieProperties(props.job.id));
        break;
      case "lift":
        localStorage.removeItem("liftTableState");
        dispatchForAction(fetchLiftFilterData(props.job.id));
        break;
      case "ranker":
        // clearing selected interactions filter and tab
        localStorage.removeItem("selectedInteractions");
        localStorage.removeItem("rankerCurrTab");
        localStorage.removeItem("rankerCustomInteractions");
        localStorage.removeItem("rankerTableState");
        dispatchForAction(fetchRankerProperties({ task_id: props.job.id }));
        break;
      case "reinvent":
        localStorage.removeItem("leaderTableState");
        dispatchForAction(fetchLeaderReinventProperties(props.job.id));
        break;
      case "bioiso":
        localStorage.removeItem("bioisoTable");
        dispatchForAction(fetchBioisostericProperties(props.job.id));
        break;
      case "rbfe":
        dispatchForAction(fetchRBFEResults(props.job.id));
        break;
      case "md_simulation":
        try {
          const MDVisualizationData = await fetchMDResults(props.job.id);
          navigate("/molecular-dynamics/lodestar/md/visualize", {
            state: {
              pdbID: "",
              pdbFile: MDVisualizationData.pdbFile,
              trajectoryFile: MDVisualizationData.trajFile,
              FileType: "pdb",
            },
          });
        } catch (error) {
          let msg: string = "";
          if (isAxiosError(error)) {
            msg = error.response?.data?.detail?.message;
          }
          dispatch(
            setGlobalMsgAlerts({
              msg: msg || errorMessages.jobResultError,
              isAlert: true,
              color: "error",
            })
          );
        }
        break;
      case "nci":
        dispatchForAction(fetchNCIResults(props.job.id));
        break;
      case "hopper":
        localStorage.removeItem("hopperTableState");
        dispatchForAction(fetchHopperResults(props.job.id));
        break;
      case "genie":
        localStorage.removeItem("selectedInteractions");
        localStorage.removeItem("genieCurrTab");
        localStorage.removeItem("genieCustomInteractions");
        localStorage.removeItem("genieTableState");
        dispatchForAction(fetchGenieProperties(props.job.id));
        break;
      default:
        break;
    }
    if (props.nextUrl) {
      trackEvent(allModuleEvents.visualization);
      navigate(props.nextUrl);
    }
  };

  function launchPropertyExplorer(
    model_name: string,
    job_id: string,
    from_model: boolean
  ) {
    const headerName = "smiles";

    if (props.handleBackdrop) props.handleBackdrop(true);
    setRequestInProgress(true);
    dispatch(
      fetchPropertiesV2({
        smiles,
        smilesFile,
        headerName,
        from_model,
        model_name,
        job_id,
      })
    )
      .then((res: any) => {
        const smilesArr: string[] = [];
        if (res.payload.properties) {
          res.payload.properties.map((item: any) => {
            smilesArr.push(item.smiles);
          });
        }
        return smilesArr;
      })
      .then((submittedSmiles: string[]) => {
        dispatch(fetchMedchemFilters({ submittedSmiles }));
        return submittedSmiles;
      })
      .then((submittedSmiles: string[]) => {
        dispatch(fetchMaiFilters({ submittedSmiles }));
        return submittedSmiles;
      })
      .then((submittedSmiles: string[]) => {
        dispatch(fetchToxicFilters({ submittedSmiles }));
        return submittedSmiles;
      })
      .then(() => {
        dispatch(fetchAllRowsFilters());
      })
      .then(() => {
        if (props.handleBackdrop) props.handleBackdrop(false);
        navigate("/virtual-screening/properties-v2/filter");
      })
      .catch((error) => {
        if (props.handleBackdrop) props.handleBackdrop(false);
        let msg: string = "Jobs has been failed for a given Job Id";
        const alertObject: GlobalMsgAlertStateType = {
          msg: msg,
          isAlert: true,
          color: "error",
        };
        dispatch(setGlobalMsgAlerts(alertObject));
      });
  }

  function launchADMEWorkflow(
    model_name: string,
    job_id: string,
    from_model: boolean
  ) {
    navigate("/models/adme", {
      state: {
        model_name: model_name,
        job_id: job_id,
        from_model: true,
      },
    });
  }

  const launchADME = () => {
    launchADMEWorkflow(MODEL_NAME, TASK_ID, true);
  };

  function launchDockingViewer(
    model_name: string,
    job_id: string,
    from_model: boolean
  ) {
    navigate("/docking/viewer", {
      state: {
        model_name: model_name,
        job_id: job_id,
        from_model: true,
      },
    });
  }

  const downloadResults = async () => {
    try {
      setDownloadResultLoader(true);
      switch (MODEL_NAME) {
        case "diffdock": {
          await downloadDiffDockResults(TASK_ID);
          break;
        }

        case "targetdiff": {
          await downloadTargetDiffResults(TASK_ID, MODEL_NAME);
          break;
        }

        case "tagmol": {
          await downloadTargetDiffResults(TASK_ID, MODEL_NAME);
          break;
        }

        case "automol": {
          await downloadAutoMolResults(TASK_ID);
          break;
        }

        case "adme_tox": {
          await downloadADMEToxResults(TASK_ID);
          break;
        }

        case "autodock": {
          await downloadAutoDockResults(TASK_ID);
          break;
        }

        case "unidock": {
          await downloadAutoDockResults(TASK_ID, MODEL_NAME);
          break;
        }
        case "promiscuity": {
          await downloadPromiscuityResults(TASK_ID);
          break;
        }

        case "screenie": {
          await downloadScreenieResults(TASK_ID);
          break;
        }

        case "maimol": {
          await downloadMaimolResults(TASK_ID);
          break;
        }

        case "lift": {
          await downloadliftResults(TASK_ID);
          break;
        }

        case "reinvent": {
          await downloadReinventResults(TASK_ID);
          break;
        }

        case "bioiso": {
          await downloadBioisoResults(TASK_ID);
          break;
        }

        case "rbfe": {
          await downloadRBFEResults(TASK_ID);
          break;
        }

        case "nci_analysis": {
          await downloadNCIResults(TASK_ID);
          break;
        }

        case "genie": {
          await downloadGenieResults(TASK_ID);
          break;
        }

        case "hopper": {
          await downloadHopperResults(TASK_ID);
          break;
        }
        default: {
          dispatch(
            setGlobalMsgAlerts({
              msg: errorMessages.genericError,
              isAlert: true,
              color: "error",
            })
          );
        }
      }
    } catch (error) {
      let msg: string = "";
      if (isAxiosError(error)) {
        msg = error.response?.data?.detail?.message;
      }
      dispatch(
        setGlobalMsgAlerts({
          msg: msg || errorMessages.jobResultError,
          isAlert: true,
          color: "error",
        })
      );
    } finally {
      setDownloadResultLoader(false);
    }
  };

  const exploreResult = async () => {
    try {
      const rankerStatus = await http.get(
        `${JOB_SERVER_URL}/ranker/status?maimol_id=${TASK_ID}&uid=${user.uid}`
      );
      if (rankerStatus.data.state !== "SUCCESS") {
        setDialogData(rankerStatus.data);
        setOpenDialog(true);
        return;
      }
      navigate("/genie/ranker/visualize");
      localStorage.removeItem("selectedInteractions");
      localStorage.removeItem("rankerCurrTab");
      localStorage.removeItem("rankerCustomInteractions");
      dispatchForAction(
        fetchRankerProperties({
          uid: user.uid,
          maimol_id: TASK_ID,
        })
      );
    } catch (error: unknown) {
      let msg = "";
      if (isAxiosError(error)) {
        msg = error.response.data?.detail?.message;
      }
      dispatch(
        setGlobalMsgAlerts({
          msg: msg || errorMessages.genericError,
          isAlert: true,
          color: "error",
        })
      );
    }
  };

  const submitNCIJob = async (p: any) => {
    try {
      const body = {
        uid: user.uid,
      };

      const response = await http.post(
        `${JOB_SERVER_URL}/nci_analysis/submit?md_id=${TASK_ID}`,
        body,
        {
          headers: {
            accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      props.onSuccessfullJobSubmission(response.data.task_id);
    } catch (error) {
      const alertObject: GlobalMsgAlertStateType = {
        msg: errorMessages.submitJobError,
        isAlert: true,
        color: "error",
      };
      dispatch(setGlobalMsgAlerts(alertObject));
    }
  };

  function showError() {
    alert(props.job?.traceback.spli);
  }

  return (
    <>
      <Grid container>
        {props.job.state === "SUCCESS" && (
          <>
            {!props.disableVisualize && (
              <Button
                variant="text"
                color="success"
                onClick={() => {
                  visualizeResults();
                }}
              >
                Visualize Results
              </Button>
            )}
            {!props.disableDownload && (
              <>
                <Box display={"flex"} flexDirection={"column"}>
                  <Button
                    variant="text"
                    onClick={() => {
                      downloadResults();
                    }}
                  >
                    Download Results
                  </Button>

                  {downloadResultLoader && (
                    <Box mt={-1}>
                      <LinearProgress color="success" />
                    </Box>
                  )}
                </Box>
              </>
            )}

            {MODEL_NAME === "maimol" && (
              <>
                <Button variant="text" color="success" onClick={exploreResult}>
                  Explore Results with Ranker
                </Button>
              </>
            )}

            {MODEL_NAME === "md_simulation" && (
              <>
                <Button
                  variant="text"
                  onClick={() => downloadMDResults(TASK_ID, "protein")}
                >
                  Download Protein
                </Button>

                <Button
                  variant="text"
                  onClick={() => downloadMDResults(TASK_ID)}
                >
                  Download Trajectory
                </Button>

                <Button variant="text" onClick={() => submitNCIJob(props)}>
                  Run with NCI
                </Button>
              </>
            )}

            {MODEL_NAME === "nci" && (
              <>
                <Button
                  variant="text"
                  onClick={() => downloadNCIResults(TASK_ID, "csv")}
                >
                  Download csv
                </Button>

                <Button
                  variant="text"
                  onClick={() => downloadNCIResults(TASK_ID)}
                >
                  Download Image
                </Button>
              </>
            )}

            {!props.handleBackdrop && (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={requestInProgress}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            )}
            {/* {
            <Button
              variant="text"
              onClick={() => {
                launchADME();
              }}
            >
              Launch ADME
            </Button>
          } */}
          </>
        )}
        {props.job.state === "FAILURE" && (
          <div>
            <Button variant="text" color="error" onClick={handleOpen}>
              See Error
            </Button>
            <Modal open={open} onClose={handleClose}>
              <Box sx={{ ...style, width: 400 }}>
                <h2>Error</h2>
                <p>
                  {props.job?.traceback
                    ? props.job?.traceback.split("\n").slice(-2)[0]
                    : ""}
                </p>
              </Box>
            </Modal>
          </div>
        )}
      </Grid>
      <JobStatusDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        data={dialogData}
      />
    </>
  );
}

export default JobDetails;
